import utils from "@/utils/common";
import api from "@/utils/api.js";
import request from "@/utils/request";
import Vue from "vue";
import storage from "../utils/storage";
const pkg = require("../../package.json");
const pjName = pkg.name;
// import vm from '../main.js'
// 修改title
window.document.title = pjName;
let vm = null;
const analyticsId = "G-PY9FLDJNVM";
const data = {
  configData: {}
};
const common_toast_en = {
  TOAST_GEM_NOT_ENOUGH:
    "Insufficient diamonds, please top up and come back again",
  TOAST_WRONG_REGION: "This event is not available for your region",
  TOAST_SERVER_TIMEOUT: "Service timeout",
  TOAST_EVENT_CLOSED_AWHILE: "The event is closed temporary",
  TOAST_SERVER_BUSY: "Server busy, please try again later",
  TOAST_OPERATE_BUSY: "Too many requests, please try again later",
  TOAST_NETWORK_BUSY: "Server busy, please try again later",
  TOAST_EVENT_END: "Event ended",
  TOAST_NETWORK_ERROR: "Network connection error, please try again later",
  TOAST_EVENT_NOTOPEN: "Event hasn't started",
  TOAST_ERROR_CODE: "Unknown error, error code {code}",
  TOAST_PAY_FAILED: "Purchase failed",
  TOAST_SERVER_NOTWORK: "Service unavailable",
  TOAST_LOGIN_FAILED: "Login failed"
};
class GaTool {
  constructor() {
    (this.data = {}), (this.initSuccess = false), (this.expire = null);
  }
  // 判断菜单按钮是否打开
  menuOpen(time) {
    const keys = Object.keys(time);
    const timeStatus = {};
    for (const item of keys) {
      let timeTmp = time[item];
      timeStatus[item] =
        new Date().valueOf() > new Date(timeTmp * 1000).valueOf();
    }
    // console.log(timeStatus)
    return timeStatus;
  }
  sendThis(_this) {
    vm = _this;
  }
  removeUrlParams(name) {
    utils.removeUrlParams(name);
  }
  /**
   *
   *
   * @param {*} region
   * @param {*} config
   */
  initGA (region, uid, dataLogName = '') {
    window.gtag('config', window.analyticsId, {
      dimension1: region,
      page_title: dataLogName || pjName, // defined in webpack
      page_path: '/index.html'
    })
    window.gtag('set', { user_id: uid })
    console.log(`region ${region}, uid ${uid}, datalogname ${dataLogName}, projectname ${pjName}`)
  }
  /**
   *
   * @param {*} event required
   * @param {*} status required
   */
  addGA(event, status) {
    var report = {
      event_label: status
    };
    window.gtag("event", event, report);
  }
  errorGA(err) {
    window.gtag("event", "exception", {
      description: err || "ERROR",
      fatal: false
    });
  }
  /**
   *
   * @param {*} access_token
   * @param {*} lang
   */
  gaConfig(access_token, lang, region) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      dataLayer.push(arguments);
    };
    gtag("js", new Date());
    gtag("config", analyticsId);
    this.storeParams(access_token, lang, region);
    this.removeUrlParams("access_token")
    this.getUserProfile(access_token, lang);
  }
  /**
   *
   * @param {*} access_token
   * @param {*} lang
   */
  // 用户信息存储
  storeParams(access_token, lang, region) {
    access_token && window.sessionStorage.setItem("AccessToken", access_token);
    lang && window.sessionStorage.setItem("Lang", lang);
    region && window.sessionStorage.setItem("Region", region);
  }
  testTime(initTime) {
    let timeOut = 1 * 10 * 1000; //设置超时时间： 10s
    let currentTime = new Date().getTime(); //更新当前时间
    if (currentTime - initTime > timeOut) {
      //判断是否超时
      if (this.initSuccess) {
        return 2;
      } else {
        return 1;
      }
    } else {
      return 0;
    }
  }
  /**
   * 获取uid
   * @param {*} accessToken
   * @param {*} lang
   */
  getUserProfile(accessToken, lang) {
    let that = this
    let initTime = new Date().getTime();
    let timer = setInterval(() => {
      this.expire = this.testTime(initTime);
      if (this.expire === 1 && !this.initSuccess) {
        // let file ='../static/transify/common_toast/common_toast-'+lang+'.js' || '../static/transify/common_toast/common_toast-zh-Hant'
        // const commo_toast =  require(file)
        // console.log(commo_toast)
        vm.$wsLoading.hide();
        vm.$wsMessage("serverbusy", false, true);
        clearInterval(timer);
      }
      if (this.expire === 2) {
        clearInterval(timer);
      }
    }, 1000);
    vm.$wsLoading.show();
    let tokenSet = accessToken
      ? { access_token: accessToken, lang: lang }
      : { lang: lang };
    request.get(api.userinfo, tokenSet).then(
      response => {
        if (response.status === 'success') {
          Vue.prototype.globalConfig = response.data
          let dataLogName = response.data['data_log_name'] || ''
          // 判断数据是否加载完成
          vm.isDataLoad = true;
          vm.$wsLoading.hide();
          this.initSuccess = true;
          // GA init
          this.initGA(this.data.configData.region, uid, dataLogName);
        } else  {
          vm.$wsLoading.hide();
          if (that.expire !== 1) {
            vm.$wsToast("NETWORK", "NetWork Error", true, false);
            clearInterval(timer);
          }
        }
      },
      err => {
        if(err.status==='error' ||err.status==='success'){
          this.expire=2
        }
        vm.$wsLoading.hide();
        this.addGA("getUserProfile", "fail");
        this.errorGA(err);
        // vm.$wsToast(null,msg,true,false)
      }
    );
    // .finally(()=>{
    //     this.initConfig(lang,data.uid)
    // })
    return this.data;
  }
  /**
   *
   * @param {*} lang
   * @param {*} uid
   * 0 networkError
   * 1 unlogin
   * 2 success
   */
  // 活动配置初始化
  initConfig(lang, uid) {
    let result = {};
    request.get(api.link.config, { lang: lang }).then(
      response => {
        if (response && response.status === "success") {
          this.addGA("initConfig", "success");
          data.configData = response.data;
          this.data = data;
          // GA init
          this.initGA(this.data.configData.region);
          // 所有config数据在globalConfig里
          Vue.prototype.globalConfig = data;
          // 判断数据是否加载完成
          vm.isDataLoad = true;
          vm.$wsLoading.hide();
        } else {
          vm.$wsLoading.hide();
          vm.$wsToast("NETWORK", "NetWork Error", true, false);
          this.addGA("initConfig", "error");
        }
        window.gtag("set", {
          user_id: uid || ""
        });
      },
      err => {
        vm.$wsLoading.hide();
        let msg = JSON.stringify(err);
        if (err.msg) {
          msg = err.msg;
        }
        this.errorGA(err);
        this.errorGA("initConfig", "fail");
        vm.$wsToast("NETWORK", "NetWork Error", true, false);
      }
    );
  }
  getCss (region,lang){
    let css = "";
    request.get(api.css,{region:region,lang:lang})
    .then(response=>{
      if(response){
        css = response
        var style = document.createElement('style')
        style.type = 'text/css';
        let head = document.head || document.getElementsByTagName('head')[0];
        var textNode = document.createTextNode(css);
        style.appendChild(textNode);
        head.appendChild(style)
      }
      this.addGA('getCss','success')
    },(err)=>{
        vm.$wsToast("NETWORK", "NetWork Error", true, false);
        this.errorGA('getCss','fail')
    })
  }
  //如果没有region或者region错误，直接返回US_en。如果是默认语言，则返回region，否则返回region_lang
  getRegionLang(region, lang){
      this.getCss(region,lang)
  }
}
export default new GaTool();



// WEBPACK FOOTER //
// ./src/utils/ga.js